import React, { Component } from 'react'
import CourseTable from './RoutineTable';
import CourseAdd from './RoutineAdd';
import { LinearProgress } from '@material-ui/core';
import Snack from '../../Snackbar/Snack';
import { PostData, GetData, PutData, DeleteData } from '../../../api/service';
import { confirmAlert } from 'react-confirm-alert'; // Import
import 'react-confirm-alert/src/react-confirm-alert.css' // Import css



export default class OpeningBalance extends Component {
    constructor(props) {
        super(props);

        this.state = {
            show: false,
            isLoading: true,
            status: false,
            message: '',
            table_data: [],
            edit: false,
            edit_data: [],
            is_all_loaded: false,
            op_head: [],
            op_account: [],
            isLoadedData: false
        }

    }

    __getFetchData = () => {
        GetData(`/getaccountshead`)
        .then((resp) => {
            GetData(`/${this.props.apikey}/${this.props.username}/getbanks`)
            .then((res) => {
                this.setState({
                    op_head: resp,
                    op_account: res,
                    isLoadedData: true
                })
            })
        })
    }

    __getData() {
        GetData(`/${this.props.apikey}/${this.props.username}/${this.props.link}`)
            .then((resp) => {
                //console.log(resp)
                this.setState({
                    table_data: resp,
                    isLoading: false
                })
            })
    }

    componentDidMount() {
        this.__getData();
        this.__getFetchData();
    }

    componentDidUpdate(prevProps) {
        if(prevProps !== this.props){
            this.setState({
                isLoading: true
            }, () => this.__getData());
        }   
    }
    


    onAddClick() {
        this.setState({
            show: !this.state.show,
            edit: false 
        })
    }
    

    setData(data) {
        //send the data to the server

        PostData(`/${this.props.apikey}/${this.props.username}/addopeningbalance`, data)
            .then((resp) => {
                //console.log(resp);
                this.setState({
                    show: false,
                    status: true,
                    message: resp,
                    edit: false
                })
                this.__getData();
            })
    }

    actionClick(el) {
        this.setState({
            edit: true,
            edit_data: el,
            show: true
        })
    }

    esetData(data) {
        //send the data to the server

        PutData(`/${this.props.apikey}/${this.props.username}/${data.id}/updateopeningbalance`, data)
            .then((resp) => {
                //console.log(resp);
                this.setState({
                    show: false,
                    status: true,
                    message: resp
                })
                this.__getData();
            })
    }

    onDeleteClick(id) {
        this.setState({
            show: false
        })
        confirmAlert({
            title: 'Confirm to delete',
            message: 'Are you sure to do this.',
            buttons: [
                {
                    label: 'Yes',
                    onClick: this.onDeleteConfirm.bind(this, id)
                },
                {
                    label: 'No'
                }
            ]
        })
    }

    onDeleteConfirm(id) {
        DeleteData(`/${this.props.apikey}/${this.props.username}/${id}/deleteopeningbalance`)
            .then((resp) => {
                this.setState({
                    show: false,
                    status: true,
                    message: resp
                })
                this.__getData();
            })
    }

    onButtonClick = (id) => {
        this.props.history.push('/accounts/view', id);
    }


    render() {
        return (
            <div>
                {this.state.status ? <Snack
                    open={this.state.status}
                    message={this.state.message}
                    handleClose={() =>
                        this.setState({
                            status: false,
                            message: ''
                        })
                    } /> : null}
                {this.state.isLoading ? <LinearProgress color="secondary" /> : null}


                <CourseAdd
                    show={this.state.show}
                    handleClose={this.onAddClick.bind(this)}
                    setData={this.setData.bind(this)}
                    edit={this.state.edit}
                    edit_data={this.state.edit_data}
                    esetData={this.esetData.bind(this)}
                    onDeleteClick={this.onDeleteClick.bind(this)}
                    is_all_loaded={this.state.is_all_loaded}
                    title={this.props.title}
                    type={this.props.type}
                    op_head={this.state.op_head}
                    op_account={this.state.op_account}
                    isLoadedData={this.state.isLoadedData}
                    
                />



                {!this.state.isLoading ? <CourseTable
                    table_data={this.state.table_data}
                    isLoading={this.state.isLoading}
                    onAddClick={this.onAddClick.bind(this)}
                    onButtonClick={this.onButtonClick.bind(this)}
                    title={this.props.title}
                    type={this.props.type}
                    actionClick={this.actionClick.bind(this)} /> : null}
            </div>
        )
    }
}
